"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitByApikey = exports.getDataByGW = exports.getOrders = exports.getBundleFee = exports.getItemMeta = exports.genNodeAPI = exports.genAPI = void 0;
const currencies_1 = __importDefault(require("bundlr-arseeding-client/build/web/currencies"));
const ethers_1 = require("ethers");
const everpay_1 = __importDefault(require("everpay"));
const arseeding_arbundles_1 = require("arseeding-arbundles");
const ethereumSigner_1 = __importDefault(require("arseeding-arbundles/src/signing/chains/ethereumSigner"));
const axios_1 = __importDefault(require("axios"));
const payOrder_1 = require("./payOrder");
const genAPI = async (windowEthereum) => {
    await windowEthereum.enable();
    // metamask 签名认证，目的是读取到 public key
    const provider = new ethers_1.providers.Web3Provider(windowEthereum);
    await provider._ready();
    const currencyConfig = (0, currencies_1.default)('ethereum', provider);
    await currencyConfig.ready();
    const signer = await currencyConfig.getSigner();
    return {
        signer,
        async sendAndPay(arseedingUrl, data, tokenSymbol, opts, debug) {
            var _a;
            const dataItem = (0, arseeding_arbundles_1.createData)(data, signer, opts);
            await dataItem.sign(signer);
            const api = axios_1.default.create({ baseURL: arseedingUrl });
            const res = await api.post(`/bundle/tx/${tokenSymbol}`, dataItem.getRaw(), {
                headers: { 'Content-Type': 'application/octet-stream' },
                maxBodyLength: Infinity
            });
            const order = res.data;
            const { fee } = order;
            if (+fee > 0) {
                const accounts = await provider.listAccounts();
                const account = (_a = accounts[0]) !== null && _a !== void 0 ? _a : '';
                const everpay = new everpay_1.default({
                    debug: debug,
                    account: account,
                    ethConnectedSigner: provider.getSigner(),
                    chainType: 'ethereum'
                });
                const everHash = await (0, payOrder_1.payOrder)(everpay, order);
                return {
                    everHash,
                    order
                };
            }
            else {
                return {
                    order
                };
            }
        }
    };
};
exports.genAPI = genAPI;
const genNodeAPI = (pk) => {
    const signer = new ethereumSigner_1.default(pk);
    const ethConnectedSigner = new ethers_1.Wallet(pk);
    return {
        signer,
        async sendAndPay(arseedingUrl, data, tokenSymbol, opts, debug) {
            const dataItem = (0, arseeding_arbundles_1.createData)(data, signer, opts);
            await dataItem.sign(signer);
            const api = axios_1.default.create({ baseURL: arseedingUrl });
            const res = await api.post(`/bundle/tx/${tokenSymbol}`, dataItem.getRaw(), {
                headers: { 'Content-Type': 'application/octet-stream' },
                maxBodyLength: Infinity
            });
            const order = res.data;
            const { fee } = order;
            if (+fee > 0) {
                const account = ethConnectedSigner.address;
                const everpay = new everpay_1.default({
                    debug: debug,
                    account: account,
                    ethConnectedSigner: ethConnectedSigner,
                    chainType: 'ethereum'
                });
                const everHash = await (0, payOrder_1.payOrder)(everpay, order);
                return {
                    everHash,
                    order
                };
            }
            else {
                return {
                    order
                };
            }
        }
    };
};
exports.genNodeAPI = genNodeAPI;
const getItemMeta = async (arseedingUrl, itemId) => {
    const api = axios_1.default.create({ baseURL: arseedingUrl });
    const res = await api.get(`bundle/tx/${itemId}`);
    return res.data;
};
exports.getItemMeta = getItemMeta;
const getBundleFee = async (arseedingUrl, size, currency) => {
    const api = axios_1.default.create({ baseURL: arseedingUrl });
    const res = await api.get(`bundle/fee/${size}/${currency}`);
    return res.data;
};
exports.getBundleFee = getBundleFee;
const getOrders = async (arseedingUrl, signerAddr) => {
    const api = axios_1.default.create({ baseURL: arseedingUrl });
    const res = await api.get(`bundle/orders/${signerAddr}`);
    return res.data;
};
exports.getOrders = getOrders;
const getDataByGW = async (arseedingUrl, itemId) => {
    const api = axios_1.default.create({ baseURL: arseedingUrl });
    const res = await api.get(`/${itemId}`);
    return res.data;
};
exports.getDataByGW = getDataByGW;
const submitByApikey = async (arseedingUrl, apiKey, data, contentType, tags) => {
    tags['Content-Type'] = contentType;
    const api = axios_1.default.create({ baseURL: arseedingUrl });
    const res = await api.post('/bundle/data', data, {
        headers: { 'X-API-KEY': apiKey },
        maxBodyLength: Infinity,
        params: tags
    });
    return res.data;
};
exports.submitByApikey = submitByApikey;
